import { useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { disableButtonForSeconds } from "./util";

export const ConfirmationModal = (props) => {
  const { t } = useTranslation();
  const buttonRef = useRef();

  const handleOk = () => {
    props.onOk();
    // Disable the button for 10 seconds
    if (buttonRef.current) {
      disableButtonForSeconds(buttonRef.current, 8);
    }
  };
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="confirmation-modal"
    >
      <Modal.Header closeButton={props.onHide}>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.heading}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <i
          className="bi bi-exclamation-triangle-fill"
          width="32"
          height="32"
        ></i>
        <p>{props.bodyMessage}</p>
      </Modal.Body>
      <Modal.Footer>
        {props.type === "delete" && (
          <>
            <Button onClick={props.onDelete} variant="danger">
              {t("msg_common.delete")}
            </Button>
            <Button onClick={props.onHide} variant="secondary">
              {t("msg_common.cancel")}
            </Button>
          </>
        )}
        {props.type === "common" && (
          <>
            <Button onClick={handleOk} variant="primary" ref={buttonRef}>
              {t("msg_common.ok")}
            </Button>
            <Button onClick={props.onHide} variant="secondary">
              {t("msg_common.cancel")}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};
